var _defs, _circle, _path, _path2, _rect, _rect2, _rect3, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncreasedProductivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 8,
    y1: 8,
    x2: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FE0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB58F"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 20,
    stroke: "url(#g1)",
    strokeWidth: 3,
    opacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 37L26 29L32 33L42 21",
    stroke: "url(#g1)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 21H42V26",
    stroke: "url(#g1)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 4,
    height: 8,
    rx: 2,
    fill: "url(#g1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27,
    width: 4,
    height: 13,
    rx: 2,
    fill: "url(#g1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 22,
    width: 4,
    height: 18,
    rx: 2,
    fill: "url(#g1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 21,
    r: 3,
    fill: "url(#g1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreasedProductivity);
export default __webpack_public_path__ + "static/media/Increased_Productivity.aafad808c75f89aac67b7ba3ec5b4e63.svg";
export { ForwardRef as ReactComponent };